import { useEffect } from "react";

const DEFAULT_TITLE = "Financial Edge Secure Access";
const DEFAULT_DESCRIPTION = "Secure sign-in for Financial Edge applications and portal workspaces.";

export function useAuthPageMeta(title, description = DEFAULT_DESCRIPTION) {
    useEffect(() => {
        const previousTitle = document.title;
        const titleValue = title ? `${title} | Financial Edge` : DEFAULT_TITLE;
        document.title = titleValue;

        const meta = document.querySelector('meta[name="description"]');
        const previousDescription = meta?.getAttribute("content") || "";

        if (meta) {
            meta.setAttribute("content", description);
        }

        return () => {
            document.title = previousTitle || DEFAULT_TITLE;

            if (meta) {
                meta.setAttribute("content", previousDescription || DEFAULT_DESCRIPTION);
            }
        };
    }, [description, title]);
}
